import React from 'react';
import { Row, Col, Card, CardTitle, CardBody, FormGroup, Button } from 'reactstrap';
import { useForm } from 'react-hook-form';

const Language = () => {
  const { register, handleSubmit } = useForm();
  const onSubmit = (form) => {
    // TODO: not yet implemented — this Settings form's Save is currently a no-op.
    console.log('### form ###', form);
  };
  return (
    <Card>
      <CardBody>
        <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal">
          <Row>
            <Col md="6">
              <Card>
                <CardBody>
                  <CardTitle>Default Language</CardTitle>
                  <FormGroup row>
                    <Col md="12">
                      <select {...register('default')} className="form-control">
                        <option value="english">English (ENG)</option>
                        <option value="portuguese">Portuguese (PT)</option>
                      </select>
                    </Col>
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
            <Col md="6">
              <Card>
                <CardBody>
                  <CardTitle>Other Translations</CardTitle>
                  <FormGroup row>
                    <Col md="12">
                      <select {...register('other')} className="form-control" multiple>
                        <option value="english">English (ENG)</option>
                        <option value="portuguese">Portuguese (PT)</option>
                      </select>
                    </Col>
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <div className="float-end">
            <Button type="submit" color="primary">
              Save
            </Button>
          </div>
        </form>
      </CardBody>
    </Card>
  );
};

export default Language;
